import { cn } from "utils/cn";

/** Shared background for sidebar and top navigation bar. */
export const SIDEBAR_SHELL_NAV_BG_CLASS = "bg-card";

/** Expanded app sidebar: workspace, project switcher, steps, account. */
export const APP_SIDEBAR_WIDTH_PX = 252;
/** Collapsed app sidebar: icons only, with tooltips and flyouts. */
export const APP_SIDEBAR_COLLAPSED_WIDTH_PX = 60;
/** The sidebar as a sheet below the md breakpoint. */
export const APP_SIDEBAR_MOBILE_WIDTH_PX = 300;

/** Wrapper between SidebarInset chrome and the rounded content panel. */
export const sidebarShellChromeClassName = cn(
  "app-chrome-frame flex min-h-0 flex-1 flex-col overflow-hidden",
  SIDEBAR_SHELL_NAV_BG_CLASS
);

/**
 * Main content surface below the top bar. Rounded top-left on desktop so the
 * join with the sidebar/nav chrome is curved instead of a sharp corner.
 */
export const sidebarShellContentPanelClassName = cn(
  "flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-background",
  "md:rounded-tl-[20px]"
);
